module.exports = __webpack_public_path__ + "static/media/  (179).aa08ab4e.jpg";